import IComponent from "components/commons/IComponent";
import "./PanelBase.scoped.css";
import BookmarkManager from "./BookmarkManager";
import Recorder from "./Recorder";
import Printer from "./Printer";
import React from "react";
import Suggestion from "./Suggestion";
import LastUpdatedDate from "./LastUpdatedDate";
import Show from "./Show";
import Download from "./Download";
import SpotElevations from "./SpotElevation";
import GroundProfile from "./GroundProfile";
import GroundProfileAGS from "./GroundProfileAGS";
import GoogleStreetView from "./GoogleStreetView";

const PANEL_NAME_COMPONENT_MATCH = {
  Bookmark: BookmarkManager,
  Recorder: Recorder,
  Printer: Printer,
  Suggestion: Suggestion,
  LastUpdatedDate: LastUpdatedDate,
  Show: Show,
  Download: Download,
  SpotElevations: SpotElevations,
  GroundProfile: GroundProfile,
  GroundProfileAGS: GroundProfileAGS,
  GoogleStreetView,
};

class PanelBase extends IComponent {
  ref = undefined;
  initX = 0;
  initY = 0;
  initWidth = 0;
  initHeight = 0;
  mouseEvtType = undefined;
  constructor(props) {
    super(props);
    this.state = {
      currentDialogHeight: 400,
    };
    this.ref = React.createRef();
  }
  componentDidMount() {
    document.querySelector(
      ".PanelBaseTitle"
    ).onmousedown = this.updateLastPos.bind(this, "title");
    document.body.onmouseup = () => this.updateLastPos("mouseup");
    document.body.onmousemove = function(evt) {
      if (typeof this.mouseEvtType === "undefined" || evt.buttons !== 1) return;
      if (this.mouseEvtType === "title") this.moveWindow(evt);
      else this.resizeWindow(evt);
    }.bind(this);
  }
  componentWillUnmount() {}
  moveWindow(evt) {
    let windowRef = this.ref.current;
    let offsetX = (evt.clientX - this.initX) * 1.25;
    let offsetY = (evt.clientY - this.initY) * 1.25;
    windowRef.style.left = Math.max(0, offsetX) + "px";
    windowRef.style.top = Math.max(0, offsetY) + "px";
  }
  resizeWindow(evt) {
    let windowRef = this.ref.current;
    let offsetX = (evt.clientX - this.initX) * 1.25;
    let offsetY = (evt.clientY - this.initY) * 1.25;
    windowRef.style.width = this.initWidth + offsetX + "px";
    windowRef.style.height = this.initHeight + offsetY + "px";
    this.setState({
      currentDialogHeight:
        Number(this.ref.current.style.height.replace("px", "")) - 100,
    });
  }
  updateLastPos(type, evt) {
    if (type === "mouseup") {
      this.mouseEvtType = undefined;
      return;
    }
    if (evt.buttons === 1) {
      window.getSelection().removeAllRanges(); //clears any current text selection
      evt.preventDefault(); // Prevent text selection
      let target = evt.target;
      let titleDiv = document.querySelector(".PanelBaseTitle");
      let closeButton = document.querySelector(
        ".icn_3d_Elevationprofile_close"
      );
      if (
        titleDiv.contains(target) &&
        (!closeButton || !closeButton.contains(target))
      ) {
        this.initX = evt.offsetX + target.offsetLeft;
        this.initY = evt.offsetY + target.offsetTop;
      } else if (evt.target.className.indexOf("ResizeCorner") > -1) {
        this.initX = evt.clientX;
        this.initY = evt.clientY;
        this.initWidth = this.ref.current.offsetWidth;
        this.initHeight = this.ref.current.offsetHeight;
      } else return;
      this.mouseEvtType = type;
    }
  }
  render() {
    return (
      <div
        ref={this.ref}
        // onMouseMove={this.moveWindow.bind(this)}
        className={`DialogPanelWindow PanelBase ${(() => {
          switch (this.props.title) {
            case "Show":
            case "GroundProfile":
            case "GroundProfileAGS":
              return "ShowPanelBase";
            case "Download":
            case "SpotElevations":
              return "DownloadPanelBase";
          }
        })()}`}
      >
        {React.createElement(
          PANEL_NAME_COMPONENT_MATCH[this.props.title],
          {
            mapUICallback: this.props.mapUICallback,
            resizeWindow: this.resizeWindow.bind(this),
            ...this.props,
            currentDialogHeight: this.state.currentDialogHeight,
          },
          null
        )}
        {this.props.enableResize && (
          <div
            className="ResizeCorner"
            onMouseDown={(evt) => this.updateLastPos("resize", evt.nativeEvent)}

            // onMouseMove={this.resizeWindow.bind(this)}
          />
        )}
      </div>
    );
  }
}

export default PanelBase;
